/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CrossModuleActionPreviewRequest,
} from '../models/index';
import {
    CrossModuleActionPreviewRequestFromJSON,
    CrossModuleActionPreviewRequestToJSON,
} from '../models/index';

export interface GetCatalog1Request {
    sessionId: string;
    sourceModule: string;
    contextEntityType: string;
    contextEntityId: string;
}

export interface Preview1Request {
    sessionId: string;
    sourceModule: string;
    crossModuleActionPreviewRequest: CrossModuleActionPreviewRequest;
}

/**
 * CrossModuleActionsApi - interface
 * 
 * @export
 * @interface CrossModuleActionsApiInterface
 */
export interface CrossModuleActionsApiInterface {
    /**
     * Lists navigation and execute actions for a source module context, filtered by entitlements, permissions, and resolvable correlation (asset golden, CVE, case links).
     * @summary Cross-module action catalog
     * @param {string} sessionId 
     * @param {string} sourceModule 
     * @param {string} contextEntityType 
     * @param {string} contextEntityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossModuleActionsApiInterface
     */
    getCatalog1Raw(requestParameters: GetCatalog1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists navigation and execute actions for a source module context, filtered by entitlements, permissions, and resolvable correlation (asset golden, CVE, case links).
     * Cross-module action catalog
     */
    getCatalog1(requestParameters: GetCatalog1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * 
     * @summary Preview cross-module action
     * @param {string} sessionId 
     * @param {string} sourceModule 
     * @param {CrossModuleActionPreviewRequest} crossModuleActionPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CrossModuleActionsApiInterface
     */
    preview1Raw(requestParameters: Preview1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Preview cross-module action
     */
    preview1(requestParameters: Preview1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class CrossModuleActionsApi extends runtime.BaseAPI implements CrossModuleActionsApiInterface {

    /**
     * Lists navigation and execute actions for a source module context, filtered by entitlements, permissions, and resolvable correlation (asset golden, CVE, case links).
     * Cross-module action catalog
     */
    async getCatalog1Raw(requestParameters: GetCatalog1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getCatalog1().'
            );
        }

        if (requestParameters['sourceModule'] == null) {
            throw new runtime.RequiredError(
                'sourceModule',
                'Required parameter "sourceModule" was null or undefined when calling getCatalog1().'
            );
        }

        if (requestParameters['contextEntityType'] == null) {
            throw new runtime.RequiredError(
                'contextEntityType',
                'Required parameter "contextEntityType" was null or undefined when calling getCatalog1().'
            );
        }

        if (requestParameters['contextEntityId'] == null) {
            throw new runtime.RequiredError(
                'contextEntityId',
                'Required parameter "contextEntityId" was null or undefined when calling getCatalog1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['sourceModule'] != null) {
            queryParameters['sourceModule'] = requestParameters['sourceModule'];
        }

        if (requestParameters['contextEntityType'] != null) {
            queryParameters['contextEntityType'] = requestParameters['contextEntityType'];
        }

        if (requestParameters['contextEntityId'] != null) {
            queryParameters['contextEntityId'] = requestParameters['contextEntityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/cross-module-actions/catalog`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists navigation and execute actions for a source module context, filtered by entitlements, permissions, and resolvable correlation (asset golden, CVE, case links).
     * Cross-module action catalog
     */
    async getCatalog1(requestParameters: GetCatalog1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCatalog1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Preview cross-module action
     */
    async preview1Raw(requestParameters: Preview1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling preview1().'
            );
        }

        if (requestParameters['sourceModule'] == null) {
            throw new runtime.RequiredError(
                'sourceModule',
                'Required parameter "sourceModule" was null or undefined when calling preview1().'
            );
        }

        if (requestParameters['crossModuleActionPreviewRequest'] == null) {
            throw new runtime.RequiredError(
                'crossModuleActionPreviewRequest',
                'Required parameter "crossModuleActionPreviewRequest" was null or undefined when calling preview1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['sourceModule'] != null) {
            queryParameters['sourceModule'] = requestParameters['sourceModule'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/cross-module-actions/preview`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CrossModuleActionPreviewRequestToJSON(requestParameters['crossModuleActionPreviewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Preview cross-module action
     */
    async preview1(requestParameters: Preview1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.preview1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
